/**
 * Helpers for the pre-analysis prompt-injection check.
 * Kept free of Office/React so they can be tested in isolation.
 */

/** What replaces a flagged passage in the text sent to the AI. */
export const REMOVED_MARKER = "[Removed by ESI Flow: suspected instructions to AI]";

/** Fast non-cryptographic fingerprint (FNV-1a) used to tell whether the document changed. */
export function hashText(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return `${text.length}:${h.toString(16)}`;
}

/** Replace every occurrence of each flagged passage (longest first, so overlaps resolve cleanly). */
export function excludeFindings(text: string, quotes: string[]): string {
  let out = text;
  for (const quote of [...quotes].filter(Boolean).sort((a, b) => b.length - a.length)) {
    out = out.split(quote).join(REMOVED_MARKER);
  }
  return out;
}

/**
 * The first line of a flagged passage, whitespace-collapsed and trimmed to fit
 * Word's search limit (255 chars) — Word search can't match across paragraphs.
 */
export function firstSearchableLine(quote: string): string {
  const line = quote.trim().split(/[\r\n]/)[0] || "";
  return line.replace(/\s+/g, " ").trim().slice(0, 200);
}
